import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ChatBot from "./components/ChatBot";
import WhatsAppButton from "./components/WhatsAppButton";
import { Toaster } from "./components/ui/sonner";

// Kritische Seiten - sofort laden
import Home from "./pages/Home";
import Marktplatz from "./pages/Marktplatz";

// Lazy-loaded Seiten - werden erst bei Bedarf geladen
const GmbhGruenden = lazy(() => import("./pages/GmbhGruenden"));
const Komplettpaket = lazy(() => import("./pages/Komplettpaket"));
const UeberUns = lazy(() => import("./pages/UeberUns"));
const Kontakt = lazy(() => import("./pages/Kontakt"));
const Rechtliches = lazy(() => import("./pages/Rechtliches"));
const FAQ = lazy(() => import("./pages/FAQ"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogArticle = lazy(() => import("./pages/BlogArticle"));
const OnboardingForm = lazy(() => import("./pages/OnboardingForm"));
const SellerOnboardingForm = lazy(() => import("./pages/SellerOnboardingForm"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const AdminDetail = lazy(() => import("./pages/AdminDetail"));
const AdminListings = lazy(() => import("./pages/AdminListings"));
const AdminNewsletter = lazy(() => import("./pages/AdminNewsletter"));
const NewsletterBestaetigt = lazy(() => import("./pages/NewsletterBestaetigt"));

// Loading-Komponente
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <main>
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/gmbh-gruenden" element={<GmbhGruenden />} />
                <Route path="/onboarding" element={<OnboardingForm />} />
                <Route path="/seller-onboarding" element={<SellerOnboardingForm />} />
                <Route path="/komplettpaket" element={<Komplettpaket />} />
                <Route path="/marktplatz" element={<Marktplatz />} />
                <Route path="/ueber-uns" element={<UeberUns />} />
                <Route path="/kontakt" element={<Kontakt />} />
                <Route path="/rechtliches" element={<Rechtliches />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogArticle />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/listings" element={<AdminListings />} />
                <Route path="/admin/newsletter" element={<AdminNewsletter />} />
                <Route path="/admin/:type/:id" element={<AdminDetail />} />
                <Route path="/newsletter-bestaetigt" element={<NewsletterBestaetigt />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          <ChatBot />
          <WhatsAppButton />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
